import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Table } from 'antd'

@inject((store: any) => {
    const { insuranceCalculatorStore, popupStore, companiesStore } = store
    return { insuranceCalculatorStore, popupStore, companiesStore }
})
@observer
export default class MissingTable extends Component<any, any> {
    render() {
        const { insuranceCalculatorStore, sets, drug } = this.props
        let newKefelHeser = insuranceCalculatorStore.newKefelHeser
        const loading = insuranceCalculatorStore.loading
        const columns = [
            {
                title: 'ביטוחים חסרים',
                key: 'right_param_set_id',
                render: (_, record) => (
                    <span>
                        {record.title ? (
                            <span style={{ fontSize: '2rem', fontWeight: '500' }}>{record.title}</span>
                        ) : record.right_param_set_id != 20 ? (
                            sets[`id${record.right_param_set_id}`]
                        ) : (
                            drug
                        )}
                    </span>
                )
            },
            {
                title: 'כיסויים חסרים',
                key: 'missing',
                render: (_, record) => (
                    <span onClick={() => console.log(record)}>
                        {record.policies ? (
                            !record.policies.length ? (
                                'חסר מוחלט'
                            ) : (
                                <div>
                                    {Object.values(record.rights)
                                        .filter(right => !right.exist.length)
                                        .map((right, ind) => {
                                            if (ind == 0 || ind == 1) return <div key={ind}>{right.name}</div>
                                            if (ind == 2)
                                                return (
                                                    <div
                                                        key={ind}
                                                        style={{
                                                            textDecoration: 'underline',
                                                            color: 'blue',
                                                            cursor: 'pointer'
                                                        }}
                                                        onClick={() =>
                                                            this.props.popupStore.togglePopup('clarification', {
                                                                title: 'כיסויים חסרים',
                                                                rights: Object.values(record.rights).filter(
                                                                    right => !right.exist.length
                                                                )
                                                            })
                                                        }
                                                    >
                                                        קרא עוד...
                                                    </div>
                                                )
                                        })}
                                </div>
                            )
                        ) : (
                            ''
                        )}
                    </span>
                )
            },
            {
                title: `היכן ניתן לרכוש`,
                key: 'options',
                render: (_, record) => (
                    <span>
                        {record.options
                            ? record.options.map((option, ind) => (
                                  <span key={ind}>
                                      {ind ? ',' : ''}
                                      {option
                                          .split(' ')
                                          .filter(name => name != 'חברה' && name != 'לביטוח')
                                          .join(' ')}
                                  </span>
                              ))
                            : ''}
                    </span>
                )
            },
            {
                title: `הבהרה`,
                key: 'clarification',
                render: (_, record) => (
                    <span>{record.right_param_set_id == 5 ? 'מחייב בדיקה בראיזור האישי בחברת הביטוח' : ''}</span>
                )
            }
        ]

        let rows = [{ title: 'ביטוחים חסרים' }]
        if (newKefelHeser.sets) {
            Object.entries(newKefelHeser.sets)
                .filter(([key, value]) => !value.policies.length)
                .map(([key, value]) => {
                    value.right_param_set_id = key
                    rows.push(value)
                })
        }
        if (rows.length) rows.push({ title: 'כיסויים חסרים' })
        if (newKefelHeser.sets) {
            Object.entries(newKefelHeser.sets || {})
                .filter(([key, value]) => value.policies.length && value.options.length && key != 14)
                .map(([key, value]) => {
                    value.right_param_set_id = key
                    rows.push(value)
                })
        }
        return (
            <Table
                className="center-table"
                style={{ width: '100%' }}
                rowKey="id"
                loading={loading}
                columns={columns}
                dataSource={rows}
            />
        )
    }
}
